import { z } from 'zod';
/**
 * Runtime-tenants (ADR 0018). `suppohrt` is de platformeigenaar; `rhogo` is de
 * eerste klant-tenant. Gebruikers landen in een tenant via hun Entra-groep
 * (backend/src/auth/group-mapping.ts).
 */
export const SUPPOHRT_TENANT_ID = 'suppohrt';
export const RHOGO_TENANT_ID = 'rhogo';
/**
 * Een zorggroep-rol hoort sinds ADR 0018 in tenant `rhogo`. Zo'n account dat
 * nog in `suppohrt` staat (binnengekomen via de oude mapping) verhuist pas bij
 * de eerste login nadat het RHOGO-slot open is. Tot dan mag het in SUPPOHRT
 * nergens opduiken: niet als sessie, niet in het Smoelenboek, niet als
 * DM-ontvanger.
 */
export function wachtOpVerhuizingNaarRhogo(user) {
    return user.tenantId === SUPPOHRT_TENANT_ID && user.role.startsWith('zorggroep_');
}
/**
 * Modules die per tenant aan of uit staan. Kern-onderdelen die elke tenant
 * nodig heeft om de app te kunnen gebruiken (profiel, meldingen, help, wat is
 * nieuw, wijzigingsverzoeken, welkomstpaneel) staan hier bewust niet in.
 */
export const TenantModule = z.enum([
    'nieuws',
    'agenda',
    'smoelenboek',
    'chats',
    'socialeKaart',
    'mila',
    'documenten',
    'sara',
    'verwijsbrieven',
    'intervisie',
    'academy',
    'eHealth',
    'uren',
    'declaraties',
    'incidenten',
    'handigeLinks',
    // De changelog beschrijft de SUPPOHRT-app en haar releases; voor RHOGO
    // is dat ruis (besluit Jos 26 okt 2026).
    'watIsNieuw',
]);
/**
 * Vaste lijst in code, geen Firestore-instelling: een module aanzetten voor
 * een tenant is een codewijziging met review (besluit 26 okt 2026). Een tenant
 * die hier niet staat krijgt niets (deny-by-default).
 */
export const TENANT_MODULES = {
    [SUPPOHRT_TENANT_ID]: TenantModule.options,
    // Sara staat uit: het menu-item blijft zichtbaar en toont "nog niet
    // beschikbaar". Intervisie en Academy komen later; Academy pas als de
    // e-learningvoortgang per tenant is gesplitst (ADR 0018).
    [RHOGO_TENANT_ID]: [
        'nieuws',
        'agenda',
        'smoelenboek',
        'chats',
        'socialeKaart',
        'mila',
        'documenten',
    ],
};
/** Staat `module` aan voor deze tenant? Naam is stabiel: backend én frontend leunen erop. */
export function tenantHasModule(tenantId, module) {
    if (!tenantId || !Object.prototype.hasOwnProperty.call(TENANT_MODULES, tenantId))
        return false;
    return TENANT_MODULES[tenantId].includes(module);
}
//# sourceMappingURL=tenant-modules.js.map